export default __webpack_public_path__ + "static/fk-4fe790eaf9287909d8bdf765a68d2a00.svg";